export default {
  pessoa_tipo: [
    { value: 1, text: 'Pessoa Física' },
    { value: 2, text: 'Pessoa Jurídica' }
  ],

  pessoa_dependente_tipo: [
    { value: 11, text: '11 - Companheiro(a) com o(a) qual o(a) contribuinte tenha filho(a) ou viva há mais de 5 (cinco) anos, ou cônjuge.' },
    { value: 21, text: '21 - Filho(a) ou enteado(a) até 21 (vinte e um) anos.' },
    { value: 22, text: '22 - Filho(a) ou enteado(a) cursando estabelecimento de ensino superior ou escola técnica de 2º grau, até 24 (vinte e quatro) anos.' },
    { value: 23, text: '23 - Filho(a) ou enteado(a) em qualquer idade, quando incapacitado física e/ou mentalmente para o trabalho.' },
    { value: 24, text: '24 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, do(a) qual o contribuinte detém a guarda judicial, até 21 (vinte e um) anos.' },
    { value: 25, text: '25 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, com idade até 24 anos, se ainda estiver cursando estabelecimento de ensino superior ou escola técnica de 2º grau, desde que o contribuinte tenha detido sua guarda judicial até os 21 anos.' },
    { value: 26, text: '26 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, do(a) qual o contribuinte detém a guarda judicial, em qualquer idade, quando incapacitado física e/ou mentalmente para o trabalho.' },
    { value: 31, text: '31 - Pais, avós e bisavós que, em 2018, receberam rendimentos, tributáveis ou não, até R$ 22.847,76.' },
    { value: 41, text: '41 - Menor pobre, até 21 (vinte e um) anos, que o contribuinte crie e eduque e do qual detenha a guarda judicial.' },
    { value: 51, text: '51 - A pessoa absolutamente incapaz, da qual o contribuinte seja tutor ou curador.' },
  ],

  contato_tipo: [
    { value: 1, text: 'Celular' },
    { value: 2, text: 'Telefone Fixo' },
    { value: 3, text: 'E-mail' }
  ],

  usuario_acesso: [
    { value: 'admin', text: 'Administrador' },
    { value: 'user', text: 'Usuário' },
    { value: 'dev', text: 'Desenvolvedor' }
  ],

  bem_direito_grupo: [
    { value: 1, text: '1 - Bens Imóveis' },
    { value: 2, text: '2 - Bens Móveis' },
    { value: 3, text: '3 - Participações Societárias' },
    { value: 4, text: '4 - Aplicações e Investimentos' },
    { value: 5, text: '5 - Créditos' },
    { value: 6, text: '6 - Depósitos à Vista e Numerário' },
    { value: 7, text: '7 - Fundos' },
    { value: 8, text: '8 - Criptoativos' },
    { value: 99, text: '99 - Outros Bens e Direitos' }
  ],

  bem_direito_codigo: [
    { value: 1, grupo: 1, text: '1 - Prédio Residencial' },
    { value: 2, grupo: 1, text: '2 - Prédio Comercial' },
    { value: 3, grupo: 1, text: '3 - Galpão' },
    { value: 11, grupo: 1, text: '11 - Apartamento' },
    { value: 12, grupo: 1, text: '12 - Casa' },
    { value: 13, grupo: 1, text: '13 - Terreno' },
    { value: 14, grupo: 1, text: '14 - Imóvel Rural' },
    { value: 15, grupo: 1, text: '15 - Sala ou Conjunto' },
    { value: 16, grupo: 1, text: '16 - Construção' },
    { value: 17, grupo: 1, text: '17 - Benfeitorias' },
    { value: 18, grupo: 1, text: '18 - Loja' },
    { value: 19, grupo: 1, text: '19 - Garagem Avulsa' },
    { value: 99, grupo: 1, text: '99 - Outros Bens Imóveis' },
    { value: 1, grupo: 2, text: '1 - Veículo Automotor Terrestre: Caminhão, Automóvel, Moto etc.' },
    { value: 2, grupo: 2, text: '2 - Aeronave' },
    { value: 3, grupo: 2, text: '3 - Embarcação' },
    { value: 4, grupo: 2, text: '4 - Bens Relacionados ao Exercício da Atividade Autônoma' },
    { value: 5, grupo: 2, text: '5 - Quadro, objeto de arte, de coleção, de antiguidade, etc.' },
    { value: 6, grupo: 2, text: '6 - Joia' },
    { value: 99, grupo: 2, text: '99 - Outros Bens Móveis' },
    { value: 1, grupo: 3, text: '1 - Ações (inclusive listadas em bolsa)' },
    { value: 2, grupo: 3, text: '2 - Quotas ou quinhões de Capital' },
    { value: 3, grupo: 3, text: '3 - Holding Patrimonial - ações ou quotas adquiridas por integralização de bens( já declarados) ao capital' },
    { value: 99, grupo: 3, text: '99 - Outras participações Societárias' },
    { value: 1, grupo: 4, text: '1 - Depósito em Conta Poupança' },
    { value: 2, grupo: 4, text: '2 - Títulos Públicos e privados sujeitos a tributação (Tesouro Direto, CDB, RDB e outros)' },
    { value: 3, grupo: 4, text: '3 - Títulos isentos de tributação (LCI, LCA, LCD, CRI, CRA, LIG, Debêntures de Infraestrutura e Outros)' },
    { value: 4, grupo: 4, text: '4 - Ativos Negociados em bolsa no Brasil (BDRs, opções e outros - exeto ações e fundos)' },
    { value: 5, grupo: 4, text: '5 - Ouro, Ativo Financeiro' },
    { value: 99, grupo: 4, text: '99 - Outras Aplicações e Investimentos' },
    { value: 1, grupo: 5, text: '1 - Empréstimos Concedidos' },
    { value: 2, grupo: 5, text: '2 - Crédito Decorrente de Alienação' },
    { value: 99, grupo: 5, text: '99 - Outros Créditos e Poupança Vinculados' },
    { value: 1, grupo: 6, text: '1 - Depósito em Conta Corrente ou Conta Pagamento' },
    { value: 2, grupo: 6, text: '2 - Conta gráfica mantida em agente operador de loterias de apostas de quota fixa - Lei 14.790/2023' },
    { value: 10, grupo: 6, text: '10 - Dinheiro em Espécie - Moeda Nacional' },
    { value: 11, grupo: 6, text: '11 - Dinheiro em Espécie - Moeda Estrangeira' },
    { value: 99, grupo: 6, text: '99 - Outros Depósitos à Vista' },
    { value: 1, grupo: 7, text: '1 - Fundo de Investimento Sujeitos à Tributação Periódica (come-cotas)' },
    { value: 2, grupo: 7, text: '2 - Fundo de Investimento Nas Cadeias Produtivas Agroindustriais (Fiagro)' },
    { value: 3, grupo: 7, text: '3 - Fundo de Investimento Imobiliário (FII)' },
    { value: 4, grupo: 7, text: '4 - Fundo de Investimento em Ações e Fundos Mútuos de Privatização - FGTS' },
    // { value: 5, grupo: 7, text: '5 - Fundo de Investimento em Ações - Mercado de Acesso' },
    { value: 6, grupo: 7, text: '6 - FIP - Entidade de investimento, FIDC - Entidade de investimento sem tributação periódica (come-cotas), ETF - Entidade de investimentos' },
    { value: 7, grupo: 7, text: '7 - Fundo de Investimento em Participações em Infraestrutura (FIP-IE) e Fybdis de Investimento em Participação na Produção Econômica Intensiva em Pesquisa Desenvolvimento e Inovação (FIP-PD&I)' },
    { value: 8, grupo: 7, text: '8 - Fundo de Índice de Renda Fixa - Lei 13.043/14' },
    // { value: 9, grupo: 7, text: '9 - Fundo de Fundos de Índice de Mercado (ETFs)' },
    { value: 10, grupo: 7, text: '10 - Fundos de Infraestrutura, FIDC e outros fundos de investimento (alíquota 0%)' },
    // { value: 11, grupo: 7, text: '11- Fundo de Investimento sem Tributação Periódica' },
    { value: 12, grupo: 7, text: '12 - Fundos de Investimentos em Empresas Emergente - FIEE' },
    { value: 13, grupo: 7, text: '13 - Fundo multimercado Lei 14.754/2023, art.25 e art 40' },
    { value: 99, grupo: 7, text: '99 - Fundos de investimento no Exterior' },
    { value: 1, grupo: 8, text: '1 - Criptoativo Bitcoin - BTC' },
    { value: 2, grupo: 8, text: '2 - Outras criptomoedas, conhecidas com altcoins, por exemplo, Ether (ETH), Ripple (XRP), Bitcoin Cash (BHC) e Litecoin (LTC)' },
    { value: 3, grupo: 8, text: '3 - Criptoativos conhecidos como stablecoins, por exemplo, Tether(USDT), USD coin(USDC), Brazilian Digital Token (BRZ), Binance USD (BUSD), DAI, True USD (TUSD)m Grmini USD(GUSD), Paxos USD (PAX), Paxos Gold (PAXG), etc' },
    { value: 10, grupo: 8, text: '10 - Criptoativos conhecidos como NFTs (Non-Funfible Tokens)' },
    { value: 99, grupo: 8, text: '99 - Outros Criptoativos' },
    { value: 1, grupo: 99, text: '1 - Licença e Concessão Especiais' },
    { value: 2, grupo: 99, text: '2 - Título de Clube e Assemelhado' },
    { value: 3, grupo: 99, text: '3 - Direito de Autor, de Inventor e Patente' },
    { value: 4, grupo: 99, text: '4 - Direito de Lavra e Assemelhado' },
    { value: 5, grupo: 99, text: '5 - Consórcio Não Contemplado' },
    { value: 6, grupo: 99, text: '6 - VGBL - Vida Gerador de Benefício Livre' },
    { value: 7, grupo: 99, text: '7 - Juros Sobre Capital Próprio Creditado, mas não Pago' },
    { value: 8, grupo: 99, text: '7 - Leasing com opção de compra a ser exercida no final do contrato' },
    { value: 99, grupo: 99, text: '99 - Outros Bens e Direitos' }
  ],

  bem_direito_banco: [
    { value: 75, text: '075 - ABN AMRO' },
    { value: 332, text: '332 - ACESSO SOLUCOES DE PAGAMENTO S.A.' },
    { value: 117, text: '117 - ADVANCED CORRETORA DE CAMBIO LTDA' },
    { value: 123, text: '123 - AGIPLAN FINANCEIRA S.A. CREDITO, FINANCIAMENTO E I' },
    { value: 272, text: '272 - AGK Corretora de Cambio S.A.' },
    { value: 172, text: '172 - Albatross Corretora de Cambio e Valores S.A' },
    { value: 349, text: '349 - AMAGGI S.A. - CREDITO, FINANCIAMENTO E INVESTIMENT' },
    { value: 188, text: '188 - Ativa Investimentos S.A. Corretora de Titulos Camb' },
    { value: 280, text: '280 - Avista S.A. Credito, Financiamento e Investimento' },
    { value: 654, text: '654 - BANCO A.J. RENNER S.A.' },
    { value: 61, text: '061 - BANCO ABB SA' },
    { value: 246, text: '246 - BANCO ABC BRASIL S.A.' },
    { value: 356, text: '356 - BANCO ABN AMRO REAL S.A.' },
    { value: 121, text: '121 - BANCO AGIBANK S.A.' },
    { value: 25, text: '025 - BANCO ALFA S/A' },
    { value: 641, text: '641 - BANCO ALVORADA S.A.' },
    { value: 65, text: '065 - BANCO ANDBANK (BRASIL) S.A.' },
    { value: 621, text: '621 - BANCO APLICAP S.A.' },
    { value: 625, text: '625 - BANCO ARAUCARIA S.A.' },
    { value: 213, text: '213 - BANCO ARBI S.A.' },
    { value: 201, text: '201 - BANCO AXIAL S.A.' },
    { value: 19, text: '019 - BANCO AZTECA DO BRASIL S.A.' },
    { value: 239, text: '239 - BANCO BANCRED S.A.' },
    { value: 67, text: '067 - BANCO BANEB SA' },
    { value: 38, text: '038 - BANCO BANESTADO S.A.' },
    { value: 740, text: '740 - BANCO BARCLAYS S.A.' },
    { value: 330, text: '330 - Banco Bari de Investimentos e Financiamentos S.A' },
    { value: 267, text: '267 - BANCO BBM-COM.C.IMOB.CFI S.A.' },
    { value: 291, text: '291 - BANCO BCN S.A.' },
    { value: 68, text: '068 - BANCO BEA S.A' },
    { value: 34, text: '034 - BANCO BEA S.A.' },
    { value: 35, text: '035 - BANCO BEC S.A.' },
    { value: 31, text: '031 - BANCO BEG S.A.' },
    { value: 48, text: '048 - BANCO BEMGE S.A.' },
    { value: 346, text: '346 - BANCO BFB _ EM ABSORCAO' },
    { value: 388, text: '388 - BANCO BMD S.A.' },
    { value: 96, text: '096 - BANCO BMFBOVESPA' },
    { value: 318, text: '318 - BANCO BMG S.A.' },
    { value: 752, text: '752 - BANCO BNP PARIBAS BRASIL S.A' },
    { value: 248, text: '248 - BANCO BOA VISTA INTERATLANTICO S.A' },
    { value: 231, text: '231 - BANCO BOAVISTA INTERATLANTICO S.A-EM ABSORCAO' },
    { value: 107, text: '107 - BANCO BOCOM BBM S.A.' },
    { value: 262, text: '262 - BANCO BOREAL S.A.' },
    { value: 36, text: '036 - BANCO BRADESCO BBI S.A.' },
    { value: 204, text: '204 - BANCO BRADESCO CARTOES S.A.' },
    { value: 394, text: '394 - BANCO BRADESCO FINANCIAMENTOS S.A.' },
    { value: 237, text: '237 - BANCO BRADESCO S.A.' },
    { value: 225, text: '225 - BANCO BRASCAN S.A.' },
    { value: 282, text: '282 - BANCO BRASILEIRO COMERCIAL S.A.- BBC' },
    { value: 501, text: '501 - BANCO BRASILEIRO IRAQUIANO S.A.' },
    { value: 218, text: '218 - BANCO BS2 S.A.' },
    { value: 44, text: '044 - BANCO BVA SA' },
    { value: 336, text: '336 - Banco C6 S.A.' },
    { value: 263, text: '263 - BANCO CACIQUE S.A.' },
    { value: 199, text: '199 - BANCO CAIXA GERAL - BRASIL S.A.' },
    { value: 473, text: '473 - BANCO CAIXA GERAL - BRASIL S.A.' },
    { value: 236, text: '236 - BANCO CAMBIAL SA' },
    { value: 412, text: '412 - BANCO CAPITAL S.A.' },
    { value: 40, text: '040 - BANCO CARGILL S.A' },
    { value: 266, text: '266 - BANCO CEDULA S.A.' },
    { value: 739, text: '739 - BANCO CETELEM S.A.' },
    { value: 221, text: '221 - BANCO CHASE FLEMING S.A.' },
    { value: 244, text: '244 - BANCO CIDADE S.A.' },
    { value: 233, text: '233 - Banco Cifra S.A.' },
    { value: 713, text: '713 - BANCO CINDAM S.A.' },
    { value: 745, text: '745 - BANCO CITIBANK S.A.' },
    { value: 241, text: '241 - BANCO CLASSICO S.A.' },
    { value: 631, text: '631 - BANCO COLUMBIA S.A.' },
    { value: 215, text: '215 - BANCO COMERCIAL E DE INVESTIMENTO SUDAMERIS S.A' },
    { value: 756, text: '756 - BANCO COOPERATIVO DO BRASIL S.A.' },
    { value: 748, text: '748 - BANCO COOPERATIVO SICREDI S.A.' },
    { value: 222, text: '222 - BANCO CREDIT AGRICOLE BRASIL S.A.' },
    { value: 640, text: '640 - BANCO CREDITO METROPOLITANO S/A' },
    { value: 505, text: '505 - BANCO CREDIT SUISSE (BRASIL) S.A.' },
    { value: 69, text: '069 - BANCO CREFISA S.A.' },
    { value: 220, text: '220 - BANCO CREFISUL S.A.' },
    { value: 628, text: '628 - BANCO CRITERIUM S. A.' },
    { value: 229, text: '229 - BANCO CRUZEIRO DO SUL S.A.' },
    { value: 3, text: '003 - BANCO DA AMAZONIA S.A.' },
    { value: 83, text: '083 - BANCO DA CHINA BRASIL S.A.' },
    { value: 733, text: '733 - BANCO DAS NACOES S.A.' },
    { value: 707, text: '707 - BANCO DAYCOVAL S.A.' },
    { value: 240, text: '240 - BANCO DE CREDITO REAL DE MINAS GERAIS S.A' },
    { value: 300, text: '300 - BANCO DE LA NACION ARGENTINA' },
    { value: 494, text: '494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY' },
    { value: 24, text: '024 - BANCO DE PERNAMBUCO S.A.-BANDEPE' },
    { value: 627, text: '627 - BANCO DESTAK S.A.' },
    { value: 456, text: '456 - BANCO DE TOKYO MITSUBISHI UFJ BRASIL S.A' },
    { value: 214, text: '214 - BANCO DIBENS S.A.' },
    { value: 369, text: '369 - BANCO DIGIBANCO S.A.' },
    { value: 335, text: '335 - BANCO DIGIO S.A.' },
    { value: 649, text: '649 - BANCO DIMENSAO S.A.' },
    { value: 1, text: '001 - BANCO DO BRASIL' },
    { value: 635, text: '635 - BANCO DO ESTADO AMAPA S.A.' },
    { value: 20, text: '020 - BANCO DO ESTADO DE ALAGOAS S.A.' },
    { value: 59, text: '059 - BANCO DO ESTADO DE RONDONIA S.A.' },
    { value: 645, text: '645 - BANCO DO ESTADO DE RORAIMA S.A.' },
    { value: 27, text: '027 - BANCO DO ESTADO DE SANTA CATARINA S.A.' },
    { value: 8, text: '008 - BANCO DO ESTADO DE SAO PAULO S.A. - BANESPA' },
    { value: 47, text: '047 - BANCO DO ESTADO DE SERGIPE S.A.' },
    { value: 26, text: '026 - BANCO DO ESTADO DO ACRE S.A.' },
    { value: 32, text: '032 - BANCO DO ESTADO DO MATO GROSSO S.A.' },
    { value: 37, text: '037 - BANCO DO ESTADO DO PARA S.A.' },
    { value: 39, text: '039 - BANCO DO ESTADO DO PIAUI S.A.-BEP' },
    { value: 41, text: '041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.' },
    { value: 4, text: '004 - BANCO DO NORDESTE DO BRASIL S.A.' },
    { value: 302, text: '302 - BANCO DO PROGRESSO S.A.' },
    { value: 245, text: '245 - BANCO EMPRESARIAL S.A.' },
    { value: 742, text: '742 - BANCO EQUATORIAL S.A.' },
    { value: 242, text: '242 - BANCO EUROINVEST S.A. EUROBANCO' },
    { value: 265, text: '265 - BANCO FATOR S.A.' },
    { value: 375, text: '375 - BANCO FENICIA S.A.' },
    { value: 224, text: '224 - BANCO FIBRA S.A.' },
    { value: 200, text: '200 - BANCO FICRISA AXELRUD S.A.' },
    { value: 626, text: '626 - BANCO FICSA S.A.' },
    { value: 725, text: '725 - BANCO FINANSINOS S. A.' },
    { value: 175, text: '175 - BANCO FINASA S.A.' },
    { value: 94, text: '094 - BANCO FINAXIS S.A.' },
    { value: 252, text: '252 - BANCO FININVEST S.A.' },
    { value: 728, text: '728 - BANCO FITAL S.A.' },
    { value: 729, text: '729 - BANCO FONTE CINDAM S.A.' },
    { value: 489, text: '489 - BANCO FRANCES INTERNACIONAL-BRASIL S.A' },
    { value: 624, text: '624 - BANCO GENERAL MOTORS S.A' },
    { value: 734, text: '734 - BANCO GERDAU S.A.' },
    { value: 612, text: '612 - BANCO GUANABARA S.A.' },
    { value: 256, text: '256 - BANCO GULFINVEST S.A.' },
    { value: 500, text: '500 - BANCO HABITASUL S.A.' },
    { value: 497, text: '497 - BANCO HISPANO AMERICANO S.A.' },
    { value: 303, text: '303 - BANCO HNF S.A.' },
    { value: 228, text: '228 - BANCO ICATU S.A.' },
    { value: 12, text: '012 - Banco Inbursa S.A.' },
    { value: 258, text: '258 - BANCO INDUSCRED S.A.' },
    { value: 604, text: '604 - BANCO INDUSTRIAL DO BRASIL S. A.' },
    { value: 653, text: '653 - BANCO INDUSVAL S.A.' },
    { value: 166, text: '166 - BANCO INTER-ATLANTICO S.A.' },
    { value: 722, text: '722 - BANCO INTERIOR DE SAO PAULO S.A.' },
    { value: 232, text: '232 - BANCO INTERPART S.A.' },
    { value: 77, text: '077 - BANCO INTER S.A.' },
    { value: 705, text: '705 - BANCO INVESTCORP S.A' },
    { value: 249, text: '249 - BANCO INVESTCRED UNIBANCO S.A' },
    { value: 499, text: '499 - BANCO IOCHPE S.A.' },
    { value: 106, text: '106 - BANCO ITABANCO S.A.' },
    { value: 372, text: '372 - BANCO ITAMARATI S/A' },
    { value: 479, text: '479 - BANCO ITAUBANK S.A.' },
    { value: 652, text: '652 - BANCO ITAU HOLDING FINANCEIRA S.A' },
    { value: 376, text: '376 - BANCO J.P. MORGAN S.A.' },
    { value: 42, text: '042 - BANCO J. SAFRA S.A' },
    { value: 74, text: '074 - BANCO J. SAFRA S.A.' },
    { value: 217, text: '217 - BANCO JOHN DEERE S.A.' },
    { value: 234, text: '234 - BANCO LAVRA S.A.' },
    { value: 600, text: '600 - BANCO LUSO BRASILEIRO S.A.' },
    { value: 72, text: '072 - BANCO MAIS S.A' },
    { value: 647, text: '647 - BANCO MARKA S.A.' },
    { value: 206, text: '206 - BANCO MARTINELLI S.A.' },
    { value: 656, text: '656 - BANCO MATRIX S.A.' },
    { value: 243, text: '243 - BANCO MAXIMA S.A.' },
    { value: 720, text: '720 - BANCO MAXINVEST S.A.' },
    { value: 392, text: '392 - BANCO MERCANTIL DE SAO PAULO S.A.' },
    { value: 389, text: '389 - BANCO MERCANTIL DO BRASIL S.A.' },
    { value: 732, text: '732 - BANCO MINAS S.A.' },
    { value: 466, text: '466 - BANCO MITSUBISHI S.A' },
    { value: 746, text: '746 - BANCO MODAL S.A.' },
    { value: 738, text: '738 - BANCO MORADA S.A.' },
    { value: 504, text: '504 - BANCO MULTIPLIC S.A.' },
    { value: 415, text: '415 - BANCO NACIONAL S.A.' },
    { value: 735, text: '735 - BANCO NEON S.A.' },
    { value: 165, text: '165 - BANCO NORCHEM S.A.' },
    { value: 151, text: '151 - BANCO NOSSA CAIXA S.A' },
    { value: 718, text: '718 - BANCO OPERADOR S.A.' },
    { value: 79, text: '079 - BANCO ORIGINAL DO AGRONEGOCIO S.A.' },
    { value: 212, text: '212 - BANCO ORIGINAL S/A' },
    { value: 208, text: '208 - BANCO PACTUAL S.A.' },
    { value: 623, text: '623 - BANCO PAN S.A.' },
    { value: 602, text: '602 - BANCO PATENTE S.A.' },
    { value: 611, text: '611 - BANCO PAULISTA S.A.' },
    { value: 650, text: '650 - BANCO PEBB S.A.' },
    { value: 643, text: '643 - BANCO PINE S.A.' },
    { value: 277, text: '277 - BANCO PLANIBANC S.A.' },
    { value: 304, text: '304 - BANCO PONTUAL S.A.' },
    { value: 658, text: '658 - BANCO PORTO REAL S.A.' },
    { value: 638, text: '638 - BANCO PROSPER S.A.' },
    { value: 747, text: '747 - BANCO RABOBANK INTERNATIONAL BRASIL S.A.' },
    { value: 88, text: '088 - BANCO RANDON S.A.' },
    { value: 275, text: '275 - BANCO REAL S.A.' },
    { value: 216, text: '216 - BANCO REGIONAL MALCON S.A.' },
    { value: 633, text: '633 - BANCO RENDIMENTO S.A.' },
    { value: 741, text: '741 - BANCO RIBEIRAO PRETO S.A.' },
    { value: 120, text: '120 - BANCO RODOBENS S.A' },
    { value: 453, text: '453 - BANCO RURAL S.A.' },
    { value: 422, text: '422 - BANCO SAFRA S.A.' },
    { value: 33, text: '033 - BANCO SANTANDER (BRASIL) S.A.' },
    { value: 353, text: '353 - BANCO SANTANDER BRASIL S.A.' },
    { value: 502, text: '502 - BANCO SANTANDER DE NEGOCIOS S.A.' },
    { value: 424, text: '424 - BANCO SANTANDER NOROESTE S.A' },
    { value: 351, text: '351 - BANCO SANTANDER S.A.' },
    { value: 607, text: '607 - BANCO SANTOS NEVES S.A.' },
    { value: 702, text: '702 - BANCO SANTOS S. A.' },
    { value: 743, text: '743 - BANCO SEMEAR S.A.' },
    { value: 749, text: '749 - BANCO SIMPLES S.A.' },
    { value: 211, text: '211 - BANCO SISTEMA S.A.' },
    { value: 630, text: '630 - BANCO SMARTBANK S.A.' },
    { value: 366, text: '366 - BANCO SOCIETE GENERALE BRASIL S.A' },
    { value: 637, text: '637 - BANCO SOFISA S.A.' },
    { value: 347, text: '347 - BANCO SUDAMERIS DO BRASIL S.A' },
    { value: 205, text: '205 - BANCO SUL AMERICA S.A.' },
    { value: 464, text: '464 - BANCO SUMITOMO MITSUI BRASILEIRO S.A.' },
    { value: 657, text: '657 - BANCO TECNICORP S.A.' },
    { value: 618, text: '618 - BANCO TENDENCIA S.A.' },
    { value: 737, text: '737 - BANCO THECA S.A.' },
    { value: 634, text: '634 - BANCO TRIANGULO S.A.' },
    { value: 247, text: '247 - BANCO UBS S.A' },
    { value: 116, text: '116 - BANCO UNICO S.A.' },
    { value: 493, text: '493 - BANCO UNION - BRASIL S.A' },
    { value: 496, text: '496 - BANCO UNO-E BRASIL S.A' },
    { value: 715, text: '715 - BANCO VEGA S.A.' },
    { value: 711, text: '711 - BANCO VETOR S.A.' },
    { value: 655, text: '655 - BANCO VOTORANTIM S.A.' },
    { value: 610, text: '610 - BANCO VR S.A.' },
    { value: 480, text: '480 - BANCO WACHOVIA S.A.' },
    { value: 124, text: '124 - BANCO WOORI BANK DO BRASIL S.A' },
    { value: 348, text: '348 - BANCO XP S.A.' },
    { value: 219, text: '219 - BANCO ZOGBI S.A' },
    { value: 28, text: '028 - BANEB-EM ABSORCAO' },
    { value: 21, text: '021 - BANESTES S.A BANCO DO ESTADO DO ESPIRITO SANTO' },
    { value: 434, text: '434 - BANFORT - BANCO FORTALEZA S.A.' },
    { value: 719, text: '719 - BANIF-BANCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A' },
    { value: 744, text: '744 - BANKBOSTON N.A.' },
    { value: 148, text: '148 - BANK OF AMERICA - BRASIL S.A. (BANCO MULTIPLO)' },
    { value: 235, text: '235 - BANK OF AMERICA - LIBERAL S.A' },
    { value: 755, text: '755 - BANK OF AMERICA MERRILL LYNCH BANCO MULTIPLO S.A.' },
    { value: 420, text: '420 - BANORTE - BANCO NACIONAL DO NORTE S.A.' },
    { value: 268, text: '268 - BARI COMPANHIA HIPOTECARIA' },
    { value: 73, text: '073 - BB BANCO POPULAR DO BRASIL' },
    { value: 81, text: '081 - BBN BANCO BRASILEIRO DE NEGOCIOS' },
    { value: 128, text: '128 - BCam MS Bank' },
    { value: 294, text: '294 - BCR/EM ABSORCAO' },
    { value: 800, text: '800 - BCR BANCO DE CREDITO REAL S.A' },
    { value: 250, text: '250 - BCV - Banco de Credito e Varejo S/A' },
    { value: 144, text: '144 - Bexs Banco de Cambio S.A.' },
    { value: 253, text: '253 - BEXS CORRETORA DE CAMBIO S/A' },
    { value: 78, text: '078 - BI HAITONG DO BRASIL' },
    { value: 129, text: '129 - BI UBS Brasil' },
    { value: 64, text: '064 - BM Goldman Sachs' },
    { value: 169, text: '169 - BM OLE BONSUCESSO CONSIGNADO S.A.' },
    { value: 712, text: '712 - BM OURINVEST' },
    { value: 18, text: '018 - BM TRICURY' },
    { value: 7, text: '007 - BNDES' },
    { value: 17, text: '017 - BNY MELLON S.A.' },
    { value: 301, text: '301 - BPP Instituicao de Pagamento S.A.' },
    { value: 63, text: '063 - BRADESCARD' },
    { value: 122, text: '122 - BRADESCO BERJ' },
    { value: 125, text: '125 - BRASIL PLURAL S.A. BANCO MULTIPLO' },
    { value: 70, text: '070 - BRB - BANCO DE BRASILIA S.A.' },
    { value: 173, text: '173 - BRL TRUST DISTRIBUIDORA DE TITULOS E VALORES MOBIL' },
    { value: 142, text: '142 - BROKER BRASIL CORRETORA DE CAMBIO LTDA.' },
    { value: 126, text: '126 - BR PARTNERS BANCO DE INVESTIMENTO S.A.' },
    { value: 292, text: '292 - BS2 Distribuidora de Titulos e Valores Mobiliarios' },
    { value: 80, text: '080 - BT Corretora de Cambio Ltda.' },
    { value: 153, text: '153 - CAIXA ECONOMICA ESTADUAL DO RIO GRANDE DO SUL' },
    { value: 104, text: '104 - CAIXA ECONOMICA FEDERAL' },
    { value: 309, text: '309 - Cambionet Corretora de Cambio Ltda.' },
    { value: 288, text: '288 - Carol Distribuidora de Titulos e Valores Mobiliari' },
    { value: 130, text: '130 - CARUANA S.A. SOCIEDADE DE CREDITO FINANCIAMENTO E' },
    { value: 159, text: '159 - Casa do Credito S.A. Sociedade de Credito ao Micro' },
    { value: 320, text: '320 - CCB BRASIL' },
    { value: 85, text: '085 - CC CECRED' },
    { value: 97, text: '097 - CC CENTRALCREDI' },
    { value: 10, text: '010 - CC CREDICOAMO' },
    { value: 89, text: '089 - CC REGIAO DA MOGIANA' },
    { value: 16, text: '016 - CC SICOOB CREDITRAN' },
    { value: 90, text: '090 - CC SICOOB UNIMAIS' },
    { value: 112, text: '112 - CC UNICRED BRASIL CENTRAL' },
    { value: 91, text: '091 - CC Unicred Central RS' },
    { value: 87, text: '087 - CC UNICRED CENTRAL SC/PR' },
    { value: 136, text: '136 - CC UNICRED DO BRASIL' },
    { value: 99, text: '099 - CC UNIPRIME CENTRAL' },
    { value: 114, text: '114 - CENTRAL COOPERATIVA DE CREDITO NO ESTADO DO ESPIRI' },
    { value: 498, text: '498 - CENTRO HISPANO BANCO' },
    { value: 477, text: '477 - CITIBANK N.A.' },
    { value: 127, text: '127 - CODEPE - CORRETORA DE VALORES S.A.' },
    { value: 163, text: '163 - COMMERZBANK' },
    { value: 133, text: '133 - CONFEDERACAO NACIONAL DAS COOPERATIVAS CENTRAIS DE' },
    { value: 281, text: '281 - COOPERATIVA DE CREDITO RURAL COOPAVEL' },
    { value: 322, text: '322 - COOPERATIVA DE CREDITO RURAL DE ABELARDO LUZ - SUL' },
    { value: 286, text: '286 - Cooperativa de Credito Rural de Ouro Sulcredi/Ouro' },
    { value: 279, text: '279 - COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' },
    { value: 273, text: '273 - Cooperativa de Credito Rural de Sao Miguel do Oest' },
    { value: 901, text: '901 - CORRETORA SOUZA BARROS CAMBIO E TITULOS S.A.' },
    { value: 98, text: '098 - CREDIALIANCA COOPERATIVA DE CREDITO RURAL' },
    { value: 109, text: '109 - CREDIBANCO S.A.' },
    { value: 721, text: '721 - CREDIBEL PARTICIPACOES S.A.' },
    { value: 22, text: '022 - CREDIREAL -EM ABSORCAO' },
    { value: 342, text: '342 - CREDITAS SOCIEDADE DE CREDITO DIRETO S.A.' },
    { value: 11, text: '011 - CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES' },
    { value: 321, text: '321 - CREFAZ SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E' },
    { value: 182, text: '182 - Dacasa Financeira S/A - Sociedade de Credito, Fina' },
    { value: 289, text: '289 - DECYSEO CORRETORA DE CAMBIO LTDA.' },
    { value: 487, text: '487 - DEUTSCHE BANK S. A. - BANCO ALEMAO' },
    { value: 210, text: '210 - DRESDNER BANK LATEINAMERIKA AKTIENGESELLSCHAFT' },
    { value: 134, text: '134 - DTVM BGC Liquidez' },
    { value: 111, text: '111 - DTVM Oliveira Trust' },
    { value: 101, text: '101 - DTVM RENASCENCA' },
    { value: 140, text: '140 - EASYNVEST - TíTULO CORRETORA DE VALORES SA' },
    { value: 103, text: '103 - EBS CAPITAL CORRETORA DE CAMBIO S/A' },
    { value: 149, text: '149 - FACTA FINANCEIRA S.A.' },
    { value: 196, text: '196 - Fair Corretora de Cambio S.A.' },
    { value: 343, text: '343 - FFA SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A' },
    { value: 331, text: '331 - FRAM CAPITAL DISTRIBUIDORA DE TITULOS E VALORES MO' },
    { value: 285, text: '285 - Frente Corretora de Cambio Ltda.' },
    { value: 278, text: '278 - GENIAL INVESTIMENTOS CORRETORA DE VALORES MOBILIAR' },
    { value: 364, text: '364 - GERENCIANET PAGAMENTOS DO BRASIL LTDA' },
    { value: 177, text: '177 - GUIDE INVESTIMENTOS S.A. CORRETORA DE VALORES' },
    { value: 146, text: '146 - GUITTA CORRETORA DE CAMBIO LTDA' },
    { value: 62, text: '062 - HIPERCARD BANCO MULTIPLO S.A' },
    { value: 269, text: '269 - HSBC Brasil S.A. Banco de Investimento' },
    { value: 168, text: '168 - HSBC INVESTMENT BANK BRASIL S.A.-BANCO MULTIPLO' },
    { value: 750, text: '750 - HSBC REPUBLIC BANK BRASIL S.A-BANCO MULTIPLO' },
    { value: 189, text: '189 - HS FINANCEIRA SA' },
    { value: 271, text: '271 - IB Corretora de Cambio, Titulos e Valores Mobiliar' },
    { value: 157, text: '157 - ICAP DO BRASIL CORRETORA DE TIT. VAL. MOBILIARIOS' },
    { value: 132, text: '132 - ICBC DO BRASIL BANCO MúLTIPLO S.A.' },
    { value: 492, text: '492 - ING BANK' },
    { value: 139, text: '139 - INTESA SANPAOLO BRASIL S.A. - DTVM' },
    { value: 184, text: '184 - ITAU BBA' },
    { value: 29, text: '029 - Itau Consignado' },
    { value: 341, text: '341 - ITAU UNIBANCO S.A.' },
    { value: 488, text: '488 - JP MORGAN CHASE BANK' },
    { value: 76, text: '076 - KDB DO BRASIL' },
    { value: 757, text: '757 - KEB HANA DO BRASIL' },
    { value: 399, text: '399 - KIRTON BANK' },
    { value: 293, text: '293 - Lastro RDV Distribuidora de Titulos e Valores Mobi' },
    { value: 105, text: '105 - LECCA CREDITO FINANCIAMENTO E INVESTIMENTO S.A.' },
    { value: 472, text: '472 - LLOYDS TSB BANK PLC' },
    { value: 113, text: '113 - MAGLIANO S.A CORRETORA CAMBIO E VALORES MOBILIARIO' },
    { value: 323, text: '323 - MERCADOPAGO.COM REPRESENTACOES LTDA.' },
    { value: 255, text: '255 - MILBANCO S.A.' },
    { value: 370, text: '370 - MIZUHO' },
    { value: 259, text: '259 - MONEYCORP BANCO DE CAMBIO S.A.' },
    { value: 274, text: '274 - MONEY PLUS SOCIEDADE DE CREDITO AO MICROEMPREENDED' },
    { value: 66, text: '066 - MORGAN STANLEY' },
    { value: 14, text: '014 - NATIXIS BRASIL' },
    { value: 354, text: '354 - NECTON INVESTIMENTOS S.A. CORRETORA DE VALORES MOB' },
    { value: 191, text: '191 - NOVA FUTURA CORRETORA DE TíTULOS E VALORES MOBILIá' },
    { value: 753, text: '753 - NOVO BANCO CONTINENTAL' },
    { value: 260, text: '260 - Nu Pagamentos S.A.' },
    { value: 86, text: '086 - OBOE CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' },
    { value: 319, text: '319 - OM DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS' },
    { value: 613, text: '613 - OMNI BANCO S.A.' },
    { value: 45, text: '045 - OPPORTUNITY HDF PARTICIPACOES S.A.' },
    { value: 325, text: '325 - ORAMA DISTRIBUIDORA DE TITULOS E VALORES MOBILIARI' },
    { value: 355, text: '355 - OTIMO SOCIEDADE DE CREDITO DIRETO S.A.' },
    { value: 290, text: '290 - Pagseguro Internet S.A.' },
    { value: 30, text: '030 - PARAIBAN-BANCO DA PARAIBA S.A.' },
    { value: 254, text: '254 - PARANA BANCO S.A.' },
    { value: 326, text: '326 - PARATI - CREDITO, FINANCIAMENTO E INVESTIMENTO S.A' },
    { value: 194, text: '194 - Parmetal Distribuidora de Titulos e Valores Mobili' },
    { value: 174, text: '174 - Pernambucanas Financiadora S.A. Credito, Financiam' },
    { value: 315, text: '315 - PI DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS' },
    { value: 108, text: '108 - PORTOCRED S A CREDITO FINANCIAMENTO E INVESTIMENTO' },
    { value: 306, text: '306 - Portopar Distribuidora de Titulos e Valores Mobili' },
    { value: 495, text: '495 - PROVINCIA B. AIRES' },
    { value: 329, text: '329 - QI SOCIEDADE DE CREDITO DIRETO S.A.' },
    { value: 283, text: '283 - RB Capital Investimentos Distribuidora de Titulos' },
    { value: 147, text: '147 - RICO CORRETORA DE TITULOS E VALORES MOBILIARIOS S/' },
    { value: 115, text: '115 - ROTULA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' },
    { value: 270, text: '270 - Sagitur Corretora de Cambio Ltda.' },
    { value: 180, text: '180 - SC CM Capital Markets' },
    { value: 60, text: '060 - SC Confidence' },
    { value: 92, text: '092 - SCFI BRICKELL' },
    { value: 138, text: '138 - SC Get Money' },
    { value: 135, text: '135 - SC Gradual' },
    { value: 145, text: '145 - SC Levycam' },
    { value: 93, text: '093 - SCM Polocred' },
    { value: 137, text: '137 - SC Multimoney' },
    { value: 751, text: '751 - SCOTIABANK BRASIL S.A BANCO MULTIPLO' },
    { value: 100, text: '100 - SC Planner' },
    { value: 545, text: '545 - SC Senso' },
    { value: 143, text: '143 - SC Treviso' },
    { value: 131, text: '131 - SC Tullett Prebon' },
    { value: 15, text: '015 - SC UBS Brasil' },
    { value: 276, text: '276 - Senff S.A. - Credito, Financiamento e Investimento' },
    { value: 13, text: '013 - SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS SA' },
    { value: 190, text: '190 - SERVICOOP - COOPERATIVA DE CREDITO DOS SERVIDORES' },
    { value: 167, text: '167 - S HAYATA CORRETORA DE CAMBIO S.A.' },
    { value: 754, text: '754 - Sistema' },
    { value: 183, text: '183 - Socred S.A. - Sociedade de Credito ao Microempreen' },
    { value: 365, text: '365 - SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIA' },
    { value: 299, text: '299 - Sorocred - Credito, Financiamento e Investimento S' },
    { value: 118, text: '118 - STANDARD CHARTERED BANK BRASIL S.A. - BANCO DE INV' },
    { value: 197, text: '197 - Stone Pagamentos S.A.' },
    { value: 340, text: '340 - SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONI' },
    { value: 307, text: '307 - Terra Investimentos Distribuidora de Titulos e Val' },
    { value: 82, text: '082 - TOPAZIO' },
    { value: 352, text: '352 - TORO CORRETORA DE TITULOS E VALORES MOBILIARIOS LT' },
    { value: 95, text: '095 - TRAVELEX BANCO DE CAMBIO S.A.' },
    { value: 409, text: '409 - UNIBANCO - UNIAO DE BANCOS BRASILEIROS S.A.' },
    { value: 230, text: '230 - UNICARD BANCO MULTIPLO S.A' },
    { value: 84, text: '084 - UNIPRIME NORTE DO PARANA - COOPERATIVA DE CREDITO' },
    { value: 373, text: '373 - UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' },
    { value: 298, text: "298 - Vip's Corretora de Cambio Ltda." },
    { value: 296, text: '296 - Vision S.A. Corretora de Cambio' },
    { value: 367, text: '367 - VITREO DISTRIBUIDORA DE TITULOS E VALORES MOBILIAR' },
    { value: 310, text: '310 - Vortx Distribuidora de Titulos e Valores Mobiliari' },
    { value: 119, text: '119 - WESTERN UNION' },
    { value: 102, text: '102 - XP INVEST CORRETORA DE CAMBIO TIT E VALORES MOB SA    ' }
  ],

  bem_direito_motivo_baixa: [
    { value: 1, text: '1 - Venda' },
    { value: 2, text: '2 - Doação' },
    { value: 3, text: '3 - Permuta' },
    { value: 4, text: '4 - Inutilização' },
    { value: 5, text: '5 - Roubo' },
    { value: 6, text: '6 - Sinistro' },
    { value: 7, text: '7 - Transferido' },
    { value: 8, text: '8 - Devolução' },
    { value: 9, text: '9 - Outros' }
  ],

  bem_direito_rural_codigo: [

    { value: 11, text: '11 - Prédios/Galpões/Estábulos/Mangueiras/Currais/Aviários/Comportas/Canais/Açudes/Barragens' },
    { value: 12, text: '12 - Cercas e Instalações para Abrigo e/ou Tratamento de Animais' },
    { value: 13, text: '13 - Eletrificação Rural, Telefone, Rádio, Bússula, Sonda, Radares' },
    { value: 14, text: '14 - Culturas Permanentes, Essências Florestais/Pastagens Artificiais' },
    { value: 15, text: '15 - Produtos Estocados' },
    { value: 16, text: '16 - Tratores/Veículos de Carga/Utilitários Rurais/Embarcações/Aeronaves de Uso Agrícola' },
    { value: 17, text: '17 - Motores e Implementos Agrícolas em Geral' },
    { value: 18, text: '18 - Equipamentos e Veículos de Tração Animal' },
    { value: 19, text: '19 - Outros Bens Móveis/Imóveis/Equipamentos da Atividade Rural' },
    { value: 20, text: '20 - Poupança p/ Aquisição Bens Móveis por Intermédio de Consórcio' },
    { value: 99, text: '99 - Outros Bens Vinculados à Atividade Rural' }

  ],

  bem_direito_rural_motivo_baixa: [
    { value: 1, text: '1 - Venda' },
    { value: 2, text: '2 - Doaçoão' },
    { value: 3, text: '3 - Permuta' },
    { value: 4, text: '4 - Inutilização' },
    { value: 5, text: '5 - Roubo' },
    { value: 6, text: '6 - Sinistro' }
  ],

  divida_onus_codigo: [

    { value: 11, text: '11 - Estabelecimento Bancário Comercial' },
    { value: 12, text: '12 - Sociedade de Crédito, Financiamento e Investimento' },
    { value: 13, text: '13 - Outras Pessoas Jurídicas' },
    { value: 14, text: '14 - Pessoas Físicas' },
    { value: 15, text: '15 - Empréstimos Contraídos no Exterior' },
    { value: 16, text: '16 - Outras Dívidas e Ônus Reais' }

  ],

  pagamento_codigo: [

    { value: 1, text: '1 - Instrução no Brasil' },
    { value: 2, text: '2 - Instrução no Exterior' },
    { value: 9, text: '9 - Fonoaudiólogos no Brasil' },
    { value: 10, text: '10 - Médicos no Brasil' },
    { value: 11, text: '11 - Dentistas no Brasil' },
    { value: 12, text: '12 - Psicólogos no Brasil' },
    { value: 13, text: '13 - Fisioterapeutas no Brasil' },
    { value: 14, text: '14 - Terapeutas Ocupacionais no Brasil' },
    { value: 15, text: '15 - Médicos no Exterior' },
    { value: 16, text: '16 - Dentistas no Exterior' },
    { value: 17, text: '17 - Psicólogos no Exterior' },
    { value: 18, text: '18 - Fisioterapeutas no Exterior' },
    { value: 19, text: '19 - Terapeutas Ocupacionais no Exterior' },
    { value: 20, text: '20 - Fonoaudiólogos no Exterior' },
    { value: 21, text: '21 - Hospitais, Clínicas e Laboratórios no Brasil' },
    { value: 22, text: '22 - Hospitais, Clínicas e Laboratórios no Exterior' },
    { value: 26, text: '26 - Planos de Saúde no Brasil' },
    { value: 30, text: '30 - Pensão Alimentícia Judicial Paga a Residente no Brasil' },
    { value: 31, text: '31 - Pensão Alimentícia Judicial Paga a Não Residente no Brasil' },
    { value: 33, text: '33 - Pensão Alimentícia - Separação/Divórcio Por Escritura Pública Paga a Residente no Brasil' },
    { value: 34, text: '34 - Pensão alimentícia - Separação/Divórcio Por Escritura Pública Paga a Não Residente no Brasil' },
    { value: 36, text: '36 - Previdência Complementar' },
    { value: 37, text: '37 - Contribuições Para as Entidades de Previdência Complementar Fechadas de Natureza Pública' },
    // 38 e 50 foram removidos no 2026
    // { value: 38, text: '38 - Fapi - Fundo de Aposentadoria Programada Individual' },
    // { value: 50, text: '50 - Contribuição patronal paga à Previdência Social pelo empregador doméstico' },
    { value: 60, text: '60 - Advogados (Honorários Relativos a Ações Judiciais, Exceto Trabalhistas)' },
    { value: 61, text: '61 - Advogados (Honorários Relativos a Ações Judiciais Trabalhistas)' },
    { value: 62, text: '62 - Advogados (Demais Honorários)' },
    { value: 66, text: '66 - Engenheiros, Arquitetos e Demais Profissionais Liberais, Exceto Advogados, Administrador de Imóveis ou Corretor de Imóveis.' },
    { value: 70, text: '70 - Aluguéis de Imóveis' },
    { value: 71, text: '71 - Administrador de Imóveis' },
    { value: 72, text: '72 - Corretor de Imóveis' },
    { value: 76, text: '76 - Arrendamento Rural' },
    { value: 99, text: '99 - Outros' }

  ],

  rend_isento_codigo_particular: [
    {
      value: 1,
      text: '1 - Bolsas de estudo e de pesquisa caracterizadas como doação, exceto médico-residente ou Pronatec, exclusivamente para proceder a estudos ou pesquisas e desde que os resultados dessas atividades não representem vantagem para o doador, nem importem contraprestação de serviços'
    },
    {
      value: 2,
      text: '2 - Bolsas de estudo e de pesquisa caracterizadas como doação, quando recebidas exclusivamente para proceder a estudos ou pesquisas, recebidas por médico-residente e por servidor da rede pública de educação profissional, científica e tecnológica que participe das atividades do Pronatec'
    },
    {
      value: 3,
      text: '3 - Capital das apólices de seguro ou pecúlio pago por morte do segurado, prêmio de seguro restituído em qualquer caso e pecúlio recebido de entidades de previdência privada em decorrência de morte ou invalidez permanente'
    },
    {
      value: 4,
      text: '4 - Indenizações por rescisão de contrato de trabalho, inclusive a título de PDV, e por acidente de trabalho; e FGTS'
    },
    {
      value: 5,
      text: '5 - Ganho de capital na alienação de bem, direito ou conjunto de bens ou direitos da mesma natureza, alienados em um mesmo mês, de valor total de alienação até R$ 20.000,00, para ações alienadas no mercado de balcão, e R$ 35.000,00, nos demais casos'
    },
    {
      value: 6,
      text: '6 - Ganho de capital na alienação do único imóvel por valor igual ou inferior a R$ 440.000,00 e que, nos últimos 5 anos, não tenha efetuado nenhuma outra alienação de imóvel'
    },
    {
      value: 7,
      text: '7 - Ganho de capital na venda de imóveis residenciais para aquisição, no prazo de 180 dias, de imóveis residenciais localizados no Brasil e redução sobre o ganho de capital'
    },
    {
      value: 8,
      text: '8 - Ganho de capital na alienação de moeda estrangeira mantida em espécie cujo total de alienações, no ano-calendário, seja igual ou inferior ao equivalente a US$ 5,000.00'
    },
    { value: 9, text: '9 - Lucros e dividendos recebidos' },
    {
      value: 10,
      text: '10 - Parcela isenta de proventos de aposentadoria, reserva remunerada, reforma e pensão de declarante com 65 anos ou mais'
    },
    {
      value: 11,
      text: '11 - Pensão, proventos de aposentadoria ou reforma por moléstia grave ou aposentadoria ou reforma por acidente  em serviço'
    },
    {
      value: 12,
      text: '12 - Rendimentos de cadernetas de poupança, letras hipotecárias, letras de crédito do agronegócio e imobiliário (LCA e LCI) e certificados de recebíveis do agronegócio e imobiliários (CRA e CRI)'
    },
    {
      value: 13,
      text: '13 - Rendimento de sócio ou titular de microempresa ou empresa de pequeno porte optante pelo Simples Nacional, exceto pro labore, aluguéis e serviços prestados'
    },
    { value: 14, text: '14 - Transferências patrimoniais – doações e heranças' },
    {
      value: 16,
      text: '16 - Imposto sobre a renda de anos-calendário anteriores compensado judicialmente neste ano-calendário'
    },
    {
      value: 17,
      text: '17 - 75% (setenta e cinco por cento) dos rendimentos do trabalho assalariado recebidos em moeda estrangeira por servidores de autarquias ou repartições do Governo Brasileiro situadas no exterior, convertidos em reais'
    },
    { value: 18, text: '18 - Incorporação de reservas ao capital / Bonificações em ações' },
    {
      value: 19,
      text: '19 - Transferências patrimoniais – meação e dissolução da sociedade conjugal e da unidade familiar'
    },
    {
      value: 20,
      text: '20 - Ganhos líquidos em operações no mercado à vista de ações negociadas em bolsas de valores nas alienações realizadas até R$ 20.000,00 em cada mês, para o conjunto de ações'
    },
    {
      value: 21,
      text: '21 - Ganhos líquidos em operações com ouro, ativo financeiro, nas alienações realizadas até R$ 20.000,00 em cada mês'
    },
    {
      value: 23,
      text: '23 - Rendimento bruto, até o máximo de 90%, da prestação de serviços decorrente do transporte de carga e com trator, máquina de terraplenagem, colheitadeira e assemelhados'
    },
    {
      value: 24,
      text: '24 - Rendimento bruto, até o máximo de 40%, da prestação de serviços decorrente do transporte de passageiros'
    },
    { value: 25, text: '25 - Restituição do imposto sobre a renda de anos-calendário anteriores' },
    { value: 28, text: '28 - Pensão Alimentícia' },
    { value: 99, text: '99 - Outros' }
  ],
  rend_isento_codigo_condominio: [
    {
      value: 3,
      text: '3 - Capital das apólices de seguro ou pecúlio pago por morte do segurado, prêmio de seguro restituído em qualquer caso e pecúlio recebido de entidades de previdência privada em decorrência de morte ou invalidez permanente'
    },
    {
      value: 9,
      text: '9 - Lucros e dividendos recebidos'
    },
    {
      value: 12,
      text: '12 - Rendimentos de cadernetas de poupança, letras hipotecárias, letras de crédito do agronegócio e imobiliário (LCA e LCI) e certificados de recebíveis do agronegócio e imobiliários (CRA e CRI)'
    },
    {
      value: 20,
      text: '20 - Ganhos líquidos em operações no mercado à vista de ações negociadas em bolsas de valores nas alienações realizadas até R$ 20.000,00 em cada mês, para o conjunto de ações'
    },
    {
      value: 21,
      text: '21 - Ganhos líquidos em operações com ouro, ativo financeiro, nas alienações realizadas até R$ 20.000,00 em cada mês'
    },
    { value: 99, text: '99 - Outros' }
  ],

  rend_tributacao_codigo: [

    { value: 6, text: '6 - Rendimentos de Aplicações Financeiras' },
    { value: 10, text: '10 - Juros sobre Capital Próprio' },
    { value: 11, text: '11 - Participação nos Lucros ou Resultados' },
    { value: 13, text: '13 - Prêmios líquidos obtidos em loterias de apostas de quota fixa - Lei 14.790/2023' },
    { value: 99, text: '99 - Outros' }

  ],

  imovel_atividade: [

    { value: 10, text: '10 - Agricultura - Cultura do Solo, Independentemente do Produto Cultivado' },
    { value: 11, text: '11 - Pecuária - Criação, Recriação ou Engorda de Animais de Médio ou Grande Porte' },
    { value: 12, text: '12 - Extração e Exploração Vegetal e Animal' },
    {
      value: 13,
      text: '13 - Exploração da Apicultura, Avicultura, Cunicultura, Piscicultura, Sericultura, Suinocultura ETC...'
    },
    { value: 14, text: '14 - Cultura de Pequenos Animais' },
    { value: 15, text: '15 - Captura e Venda do Pescado in Natura' },
    { value: 16, text: '16 - Transformação de Produtos Agrícolas ou Pecuários' },
    { value: 17, text: '17 - Cultivo de Florestas' },
    { value: 99, text: '99 - Outros' }

  ],

  imovel_exploracao: [
    { value: 1, text: '1 - Propriedade Única ou Posse' },
    { value: 2, text: '2 - Condomínio' },
    { value: 3, text: '3 - Parceria' },
    { value: 4, text: '4 - Arrendamento' },
    { value: 5, text: '5 - Propriedade Comum ao Casal' },
    { value: 6, text: '6 - Outras' }
  ],
 
  pessoa_natureza_ocupacao: [
    { text: '1 - Empregado de empresa do setor privado, exceto de instituições financeiras', value: 1 },
    { text: '2 - Empregado de instituições financeiras públicas e privadas', value: 2 },
    { text: '3 - Empregado ou contratado de organismo internacional ou de organização não-governamental', value: 3 },
    { text: '11 - Profissional liberal ou autônomo sem vínculo de emprego', value: 11 },
    { text: '12 - Proprietário de empresa ou de firma individual ou empregador-titular', value: 12 },
    { text: '13 - Capitalista, que auferiu rendimentos de capital, inclusive de aluguéis', value: 13 },
    { text: '14 - Microoempreendedor individual (MEI)', value: 14 },
    { text: '21 - Membro ou servidor público da administração direta federal', value: 21 },
    { text: '22 - Servidor público de autarquia ou fundação federal', value: 22 },
    { text: '23 - Empregado de empresa pública ou de economia mista federal, exceto de instituições financeiras', value: 23 },
    { text: '31 - Membro ou servidor público da administração direta estadual e do Distrito Federal', value: 31 },
    { text: '32 - Servidor público de autarquia ou fundação estadual e do Distrito Federal', value: 32 },
    { text: '33 - Empregado de empresa pública ou de economia mista estadual e do Distrito Federal, exceto de instituições financeiras', value: 33 },
    { text: '41 - Membro ou servidor público da administração direta municipal', value: 41 },
    { text: '42 - Servidor público de autarquia ou fundação municipal', value: 42 },
    { text: '43 - Empregado de empresa pública ou de economia mista municipal', value: 43 },
    { text: '51 - Militar', value: 51 },
    { text: '61 - Aposentado, militar da reserva ou reformado e pensionista de previdência', value: 61 },
    { text: '62 - Aposentado, militar da reserva ou reformado e pensionista de previdência oficial, portador de moléstia grave', value: 62 },
    { text: '71 - Beneficiário de pensão alimentícia judicial', value: 71 },
    { text: '72 - Bolsista', value: 72 },
    { text: '81 - Espólio', value: 81 },
    { text: '91 - Natureza da ocupação não especificada anteriormente', value: 91 }
  ],

  pessoa_ocupacao_principal: [
    { text: '101 - Membro do Poder Executivo (Presidente da República, Vice-Presidente da República, Ministro de Estado, Governador, Vice-Governador, Prefeito, Vice-prefeito)', value: 101 },
    { text: '102 - Membro do Poder Judiciário (Ministro, Juiz e Desembargador) e de Tribunal de Contas (Ministro e Conselheiro)', value: 102 },
    { text: '103 - Membro do Poder Legislativo (Senador, Deputado Federal, Deputado Estadual e Vereador)', value: 103 },
    { text: '104 - Membro do Ministério Público (Procurador e Promotor)', value: 104 },
    { text: '105 - Dirigente superior da administração pública (ocupante de cargo de direção, chefia, assessoria e de natureza especial), inclusive os das fundações públicas e autarquias', value: 105 },
    { text: '106 - Diplomata e afins', value: 106 },
    { text: '107 - Servidor das carreiras do Poder Legislativo', value: 107 },
    { text: '108 - Servidor das carreiras do Ministério Público', value: 108 },
    { text: '109 - Servidor das carreiras do Poder Judiciário, Oficial de Justiça, Auxiliar, Assistente e Analista Judiciário', value: 109 },
    { text: '110 - Advogado do setor público, Procurador da Fazenda, Consultor Jurídico, Procurador de autarquias e fundações públicas, Defensor Público', value: 110 },
    { text: '111 - Servidor das carreiras de auditoria fiscal e de fiscalização', value: 111 },
    { text: '112 - Servidor das carreiras do Banco Central, CVM e Susep', value: 112 },
    { text: '113 - Delegado de Polícia e outros servidores das carreiras de polícia, exceto militar', value: 113 },
    { text: '114 - Servidor das carreiras de gestão governamental, analista, gestor e técnico de planejamento', value: 114 },
    { text: '115 - Servidor das carreiras de ciência e tecnologia Código Natureza da Ocupação', value: 115 },
    { text: '116 - Servidor das demais carreiras da administração pública direta, autárquica e fundacional', value: 116 },
    { text: '117 - Titular de Cartório', value: 117 },
    { text: '118 - Dirigente ou administrador de partido político, organização patronal, sindical, filantrópica e religiosa', value: 118 },
    { text: '120 - Dirigente, presidente e diretor de empresa industrial, comercial ou prestadora de serviços', value: 120 },
    { text: '121 - Presidente e diretor de empresa pública e sociedade de economia mista', value: 121 },
    { text: '130 - Gerente ou supervisor de empresa industrial, comercial ou prestadora de serviços', value: 130 },
    { text: '131 - Gerente ou supervisor de empresa pública e sociedade de economia mista', value: 131 },
    { text: '140 - Presidente, diretor, gerente e supervisor de organismo internacional e de organização não-governamental', value: 140 },
    { text: '211 - Matemático, estatístico, atuário e afins', value: 211 },
    { text: '212 - Analista de sistemas, desenvolvedor de software, administrador de redes e bancos de dados e outros especialistas em informática (exceto técnico)', value: 212 },
    { text: '213 - Físico, químico, meteorologista, geólogo, oceanógrafo e afins', value: 213 },
    { text: '214 - Engenheiro, arquiteto e afins', value: 214 },
    { text: '215 - Piloto de aeronaves, comandante de embarcações e oficiais máquinas', value: 215 },
    { text: '221 - Biólogo, biomédico e afins', value: 221 },
    { text: '222 - Agrônomo e afins', value: 222 },
    { text: '224 - Profissional da educação física (exceto professor)', value: 224 },
    { text: '225 - Médico', value: 225 },
    { text: '226 - Odontólogo', value: 226 },
    { text: '227 - Enfermeiro de nível superior, nutricionista, farmacêutico e afins', value: 227 },
    { text: '228 - Veterinário, patologista (veterinário) e zootecnista', value: 228 },
    { text: '229 - Fonoaudiólogo, fisioterapeuta, terapeuta ocupacional e afins', value: 229 },
    { text: '241 - Advogado', value: 241 },
    { text: '250 - Sociólogo e cientista político', value: 250 },
    { text: '251 - Antropólogo e arqueólogo', value: 251 },
    { text: '252 - Economista, administrador, contador, auditor e afins', value: 252 },
    { text: '253 - Profissional de marketing, de publicidade e de comercialização', value: 253 },
    { text: '255 - Psicólogo e psicanalista', value: 255 },
    { text: '256 - Geógrafo', value: 256 },
    { text: '257 - Historiador', value: 257 },
    { text: '258 - Assistente social e economista doméstico', value: 258 },
    { text: '259 - Filósofo', value: 259 },
    { text: '261 - Jornalista e repórter', value: 261 },
    { text: '263 - Sacerdote ou membro de ordens ou seitas religiosas', value: 263 },
    { text: '264 - Tradutor, intérprete, filólogo', value: 264 },
    { text: '265 - Bibliotecário, documentalista, arquivólogo, museólogo', value: 265 },
    { text: '266 - Escritor, crítico, redator', value: 266 },
    { text: '271 - Locutor, comentarista', value: 271 },
    { text: '272 - Ator, diretor de espetáculos', value: 272 },
    { text: '273 - Cantor e compositor', value: 273 },
    { text: '274 - Músico, arranjador, regente de orquestra ou coral', value: 274 },
    { text: '275 - Desenhista industrial (designer), escultor, pintor artístico e afins', value: 275 },
    { text: '276 - Cenógrafo, decorador de interiores', value: 276 },
    { text: '277 - Empresário e produtor de espetáculos', value: 277 },
    { text: '279 - Outros profissionais do espetáculo e das artes', value: 279 },
    { text: '290 - Professor na educação infantil', value: 290 },
    { text: '291 - Professor do ensino fundamental', value: 291 },
    { text: '292 - Professor do ensino médio', value: 292 },
    { text: '293 - Professor do ensino profissional', value: 293 },
    { text: '294 - Professor do ensino superior', value: 294 },
    { text: '295 - Instrutor e professor de escolas livres', value: 295 },
    { text: '296 - Pedagogo, orientador educacional', value: 296 },
    { text: '311 - Técnico em ciências físicas e químicas', value: 311 },
    { text: '312 - Técnico em construção civil, de edificações e obras de infra estrutura', value: 312 },
    { text: '313 - Técnico em eletro-eletrônica e fotônica', value: 313 },
    { text: '314 - Técnico em metalmecânica', value: 314 },
    { text: '316 - Técnico em mineralogia e geologia', value: 316 },
    { text: '317 - Técnico em informática', value: 317 },
    { text: '318 - Desenhista técnico e modelista', value: 318 },
    { text: '319 - Outros técnicos de nível médio das ciências físicas, químicas, engenharia e afins', value: 319 },
    { text: '320 - Técnico em biologia', value: 320 },
    { text: '321 - Técnico da produção agropecuária', value: 321 },
    { text: '322 - Técnico da ciência da saúde humana', value: 322 },
    { text: '323 - Técnico da ciência da saúde animal', value: 323 },
    { text: '324 - Técnico de laboratório, Raios-X e outros equipamentos e instrumentos de diagnóstico', value: 324 },
    { text: '325 - Técnico de bioquímica e da biotecnologia', value: 325 },
    { text: '328 - Técnico de conservação, dissecação e empalhamento de corpos', value: 328 },
    { text: '341 - Técnico em navegação aérea, marítima, fluvial e metroferroviária', value: 341 },
    { text: '342 - Técnico em transportes (logística)', value: 342 },
    { text: '351 - Técnico das ciências administrativas e contábeis', value: 351 },
    { text: '352 - Técnico de inspeção, fiscalização e coordenação administrativa', value: 352 },
    { text: '353 - Agente de Bolsa de Valores, câmbio e outros serviços financeiros', value: 353 },
    { text: '354 - Agente e representante comercial, corretor, leiloeiro e afins', value: 354 },
    { text: '371 - Técnico de serviços culturais', value: 371 },
    { text: '372 - Cinegrafista, fotógrafo e outros técnicos em operação de máquinas de tratamento de dados', value: 372 },
    { text: '373 - Técnico em operação de estações de rádio e televisão', value: 373 },
    { text: '374 - Técnico em operação de aparelhos de sonorização, cenografia e projeção', value: 374 },
    { text: '375 - Decorador e vitrinista', value: 375 },
    { text: '376 - Apresentador, artistas de artes populares e modelos', value: 376 },
    { text: '377 - Atleta, desportista e afins', value: 377 },
    { text: '391 - Outros técnicos de nível médio', value: 391 },
    { text: '410 - Bancário, economiário, escriturário, secretário, assistente e auxiliar administrativo', value: 410 },
    { text: '420 - Trabalhador de atendimento ao público, caixa, despachante, recenseador e afins', value: 420 },
    { text: '511 - Comissário de bordo, guia de turismo, agente de viagens e afins', value: 511 },
    { text: '512 - Trabalhador dos serviços domésticos em geral', value: 512 },
    { text: '513 - Trabalhador dos serviços de hotelaria e alimentação', value: 513 },
    { text: '514 - Trabalhador dos serviços de administração, conservação e manutenção de edifícios', value: 514 },
    { text: '515 - Trabalhador dos serviços de saúde', value: 515 },
    { text: '516 - Trabalhador dos serviços de embelezamento e cuidados pessoais', value: 516 },
    { text: '517 - Trabalhador dos serviços de proteção e segurança (exceto militar)', value: 517 },
    { text: '518 - Motorista e condutor do transporte de passageiros (motorista de táxi, ônibus, pequena embarcação, etc.)', value: 518 },
    { text: '519 - Outros trabalhadores de serviços diversos', value: 519 },
    { text: '529 - Vendedor e prestador de serviços do comércio, ambulante, caixeiro-viajante e camelô', value: 529 },
    { text: '610 - Produtor na exploração agropecuária', value: 610 },
    { text: '620 - Trabalhador na exploração agropecuária', value: 620 },
    { text: '630 - Pescador, caçador e extrativista florestal', value: 630 },
    { text: '640 - Operador de máquina agropecuária e florestal', value: 640 },
    { text: '710 - Trabalhador da indústria extrativa e da construção civil', value: 710 },
    { text: '720 - Trabalhador da transformação de metais e compósitos', value: 720 },
    { text: '730 - Trabalhador da fabricação e instalação eletro-eletrônica', value: 730 },
    { text: '740 - Montador de aparelhos e instrumentos de precisão e musicais', value: 740 },
    { text: '750 - Joalheiro, vidreiro, ceramista e afins', value: 750 },
    { text: '760 - Trabalhador da indústrias têxteis, do curtimento, do vestuário e das artes gráficas', value: 760 },
    { text: '770 - Trabalhador das indústrias de madeira e do mobiliário', value: 770 },
    { text: '780 - Condutor e operador de robôs, veículos de equipamentos de movimentação de carga e afins', value: 780 },
    { text: '810 - Trabalhador das indústrias química, petroquímica, borracha e plástico e afins', value: 810 },
    { text: '820 - Trabalhador de instalações siderúrgicas e de materiais de construção', value: 820 },
    { text: '830 - Trabalhador de instalações e máquinas de fabricação de celulose e papel', value: 830 },
    { text: '840 - Trabalhador da fabricação de alimentos, bebidas, fumo e de agroindústrias', value: 840 },
    { text: '860 - Operador de instalações de produção e distribuição de energia', value: 860 },
    { text: '870 - Trabalhador de outras instalações agroindustriais', value: 870 },
    { text: '900 - Trabalhador de reparação e manutenção', value: 900 },
    { text: '010 - Militar da Aeronáutica', value: 10 },
    { text: '020 - Militar do Exército', value: 20 },
    { text: '030 - Militar da Marinha', value: 30 },
    { text: '040 - Policial Militar', value: 40 },
    { text: '050 - Bombeiro Militar', value: 50 },
    { text: '000 - Outras ocupações não especificadas anteriormente', value: 0 }
  ],

  pessoa_tipo_logradouro: [
    { value: 1, text: 'Aeroporto' },
    { value: 2, text: 'Alameda' },
    { value: 3, text: 'Área' },
    { value: 4, text: 'Avenida' },
    { value: 5, text: 'Campo' },
    { value: 6, text: 'Chácara' },
    { value: 7, text: 'Colônia' },
    { value: 8, text: 'Condomínio' },
    { value: 9, text: 'Conjunto' },
    { value: 10, text: 'Distrito' },
    { value: 11, text: 'Esplanada' },
    { value: 12, text: 'Estação' },
    { value: 13, text: 'Estrada' },
    { value: 14, text: 'Favela' },
    { value: 15, text: 'Fazenda' },
    { value: 16, text: 'Feira' },
    { value: 17, text: 'Jardim' },
    { value: 18, text: 'Ladeira' },
    { value: 19, text: 'Lago' },
    { value: 20, text: 'Lagoa' },
    { value: 21, text: 'Largo' },
    { value: 22, text: 'Linha' },
    { value: 23, text: 'Loteamento' },
    { value: 24, text: 'Margem' },
    { value: 25, text: 'Morro' },
    { value: 26, text: 'Núcleo' },
    { value: 27, text: 'Outros' },
    { value: 28, text: 'Parque' },
    { value: 29, text: 'Passagem' },
    { value: 30, text: 'Passarela' },
    { value: 31, text: 'Pátio' },
    { value: 32, text: 'Praça ' },
    { value: 33, text: 'Praia' },
    { value: 34, text: 'Quadra' },
    { value: 35, text: 'Recanto' },
    { value: 36, text: 'Residencial' },
    { value: 37, text: 'Rodovia' },
    { value: 38, text: 'Rua' },
    { value: 39, text: 'Setor' },
    { value: 40, text: 'Sítio' },
    { value: 41, text: 'Superquadra' },
    { value: 42, text: 'Travessa' },
    { value: 43, text: 'Trecho' },
    { value: 44, text: 'Trevo' },
    { value: 45, text: 'Vale' },
    { value: 46, text: 'Vereda' },
    { value: 47, text: 'Via' },
    { value: 48, text: 'Viaduto' },
    { value: 49, text: 'Viela' },
    { value: 50, text: 'Vila     ' }
  ],

  pessoa_codigo_ext: [
    { value: 200, text: '200 - Abidjan, Costa do Marfim - Embaixada do Brasil' },
    { value: 260, text: '260 - Abu Dhabi, Emirados Árabes Unidos - Embaixada do Brasil' },
    { value: 651, text: '651 - Abuja, Nigéria - Embaixada do Brasil' },
    { value: 350, text: '350 - Acra, Gana - Embaixada do Brasil' },
    { value: 306, text: '306 - Adis Abeba, Etiópia - Embaixada do Brasil' },
    { value: 550, text: '550 - Amã, Jordânia - Embaixada do Brasil' },
    { value: 930, text: '930 - Ancara, Turquia - Embaixada do Brasil' },
    { value: 40, text: '040 - Argel, Argélia - Embaixada do Brasil' },
    { value: 950, text: '950 - Artigas, Uruguai - Vice-Consulado do Brasil' },
    { value: 700, text: '700 - Assunção, Paraguai - Consulado-Geral do Brasil e Embaixada' },
    { value: 147, text: '147 - Astana, Cazaquistão - Embaixada do Brasil' },
    { value: 360, text: '360 - Atenas, Grécia - Embaixada do Brasil' },
    { value: 289, text: '289 - Atlanta, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 485, text: '485 - Bagdá, Iraque - Embaixada do Brasil' },
    { value: 821, text: '821 - Baku, Azerbaijão - Embaixada do Brasil' },
    { value: 595, text: '595 - Bamaco, Mali - Embaixada do Brasil' },
    { value: 880, text: '880 - Bangcoc, Tailândia - Embaixada do Brasil' },
    { value: 280, text: '280 - Barcelona, Espanha - Consulado-Geral do Brasil' },
    { value: 828, text: '828 - Basseterre, São Cristóvão e Névis - Embaixada do Brasil' },
    { value: 570, text: '570 - Beirute, Líbano - Embaixada do Brasil' },
    { value: 520, text: '520 - Belgrado, Sérvia - Embaixada do Brasil' },
    { value: 104, text: '104 - Belmopan, Belize - Embaixada do Brasil' },
    { value: 10, text: '010 - Berlim, Alemanha - Embaixada do Brasil' },
    { value: 400, text: '400 - Bissau, Guiné-Bissau - Embaixada do Brasil' },
    { value: 180, text: '180 - Bogotá, Colômbia - Embaixada do Brasil' },
    { value: 290, text: '290 - Boston, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 274, text: '274 - Bratislava, Eslováquia - Embaixada do Brasil' },
    { value: 187, text: '187 - Brazzaville, Congo - Embaixada do Brasil' },
    { value: 90, text: '090 - Bridgetown, Barbados - Embaixada do Brasil' },
    { value: 100, text: '100 - Bruxelas, Bélgica - Consulado-Geral do Brasil e Embaixada' },
    { value: 810, text: '810 - Bucareste, Romênia - Embaixada do Brasil' },
    { value: 440, text: '440 - Budapeste, Hungria - Embaixada do Brasil' },
    { value: 50, text: '050 - Buenos Aires, Argentina - Consulado-Geral do Brasil e Embaixada' },
    { value: 390, text: '390 - Caiena, Guiana Francesa - Consulado-Geral do Brasil' },
    { value: 240, text: '240 - Cairo, Egito - Embaixada do Brasil' },
    { value: 60, text: '060 - Camberra, Austrália - Embaixada do Brasil' },
    { value: 163, text: '163 - Cantão, China - Consulado-Geral do Brasil' },
    { value: 970, text: '970 - Caracas, Venezuela - Consulado-Geral e Embaixada' },
    { value: 847, text: '847 - Cartum, Sudão - Embaixada do Brasil' },
    { value: 823, text: '823 - Castries, Santa Lúcia - Embaixada do Brasil' },
    { value: 291, text: '291 - Chicago, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 951, text: '951 - Chuy, Uruguai - Consulado do Brasil' },
    { value: 1, text: '001 - Cidade do Cabo, África do Sul - Consulado-Geral do Brasil' },
    { value: 610, text: '610 - Cidade do México, México - Consulado-Geral e Embaixada' },
    { value: 960, text: '960 - Cidade do Vaticano, Vaticano - Embaixada do Brasil' },
    { value: 170, text: '170 - Cingapura, Cingapura - Embaixada do Brasil' },
    { value: 701, text: '701 - Ciudad Del Este, Paraguai - Consulado-Geral do Brasil' },
    { value: 971, text: '971 - Ciudad Guayana, Venezuela - Consulado do Brasil' },
    { value: 110, text: '110 - Cobija, Bolívia - Consulado do Brasil' },
    { value: 111, text: '111 - Cochabamba, Bolívia - Consulado-Geral do Brasil' },
    { value: 843, text: '843 - Colombo, Sri Lanka - Embaixada do Brasil' },
    { value: 396, text: '396 - Conacri, Guiné - Embaixada do Brasil' },
    { value: 702, text: '702 - Concepción, Paraguai - Vice-Consulado do Brasil' },
    { value: 230, text: '230 - Copenhague, Dinamarca - Embaixada do Brasil' },
    { value: 53, text: '053 - Córdoba, Argentina - Consulado-Geral do Brasil' },
    { value: 107, text: '107 - Cotonou, Benin - Embaixada do Brasil' },
    { value: 830, text: '830 - Dacar, Senegal - Embaixada do Brasil' },
    { value: 85, text: '085 - Daca, Bangladesh - Embaixada do Brasil' },
    { value: 840, text: '840 - Damasco, Síria - Embaixada do Brasil' },
    { value: 893, text: '893 - Dar-Es-Salaam, Tanzânia - Embaixada do Brasil' },
    { value: 900, text: '900 - Dili, Timor-Leste - Embaixada do Brasil' },
    { value: 143, text: '143 - Doha, Catar - Embaixada do Brasil' },
    { value: 490, text: '490 - Dublin, Irlanda - Embaixada do Brasil' },
    { value: 703, text: '703 - Encarnación, Paraguai - Vice-Consulado do Brasil' },
    { value: 850, text: '850 - Estocolmo, Suécia - Embaixada do Brasil' },
    { value: 752, text: '752 - Faro, Portugal - Consulado-Geral do Brasil' },
    { value: 11, text: '011 - Frankfurt, Alemanha - Consulado-Geral do Brasil' },
    { value: 835, text: '835 - Freetown, Serra Leoa - Embaixada do Brasil' },
    { value: 118, text: '118 - Gaborone, Botsuana - Embaixada do Brasil' },
    { value: 862, text: '862 - Genebra, Suíça - Consulado-Geral do Brasil' },
    { value: 380, text: '380 - Georgetown, Guiana - Embaixada do Brasil' },
    { value: 370, text: '370 - Guatemala, Guatemala - Embaixada do Brasil' },
    { value: 112, text: '112 - Guayaramerin, Bolívia - Consulado do Brasil' },
    { value: 542, text: '542 - Hamamatsu, Japão - Consulado-Geral do Brasil' },
    { value: 980, text: '980 - Hanói, Vietnam - Embaixada do Brasil' },
    { value: 990, text: '990 - Harare, Zimbábue - Embaixada do Brasil' },
    { value: 298, text: '298 - Hartford, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 220, text: '220 - Havana, Cuba - Embaixada do Brasil' },
    { value: 320, text: '320 - Helsinque, Finlândia - Embaixada do Brasil' },
    { value: 162, text: '162 - Hong Kong, China - Consulado-Geral do Brasil' },
    { value: 292, text: '292 - Houston, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 136, text: '136 - Iaundê, Camarões - Embaixada do Brasil' },
    { value: 57, text: '057 - Ierevan, Armênia - Embaixada do Brasil' },
    { value: 721, text: '721 - Iquitos, Peru - Consulado do Brasil' },
    { value: 690, text: '690 - Islamabade, Paquistão - Embaixada do Brasil' },
    { value: 931, text: '931 - Istambul, Turquia - Consulado-Geral do Brasil' },
    { value: 460, text: '460 - Jacarta, Indonésia - Embaixada do Brasil' },
    { value: 635, text: '635 - Kathmandu, Nepal - Embaixada do Brasil' },
    { value: 940, text: '940 - Kiev, Ucrânia - Embaixada do Brasil' },
    { value: 530, text: '530 - Kingston, Jamaica - Embaixada do Brasil' },
    { value: 693, text: '693 - Kingstown, São Vicente e Granadinas - Embaixada do Brasil' },
    { value: 776, text: '776 - Kinshasa, Congo, República Democrática do - Embaixada do Brasil' },
    { value: 560, text: '560 - Kuaite, Kuaite - Embaixada do Brasil' },
    { value: 590, text: '590 - Kuala Lumpur, Malásia - Embaixada do Brasil' },
    { value: 113, text: '113 - La Paz, Bolívia - Embaixada do Brasil' },
    { value: 650, text: '650 - Lagos, Nigéria - Consulado-Geral do Brasil' },
    { value: 381, text: '381 - Lethem, Guiana - Vice-Consulado do Brasil' },
    { value: 181, text: '181 - Letícia, Colômbia - Vice-Consulado do Brasil' },
    { value: 340, text: '340 - Libreville, Gabão - Embaixada do Brasil' },
    { value: 593, text: '593 - Lilongwe, Malauí - Embaixada do Brasil' },
    { value: 720, text: '720 - Lima, Peru - Embaixada do Brasil' },
    { value: 750, text: '750 - Lisboa, Portugal - Consulado-Geral, Embaixada' },
    { value: 277, text: '277 - Liubliana, Eslovênia - Embaixada do Brasil' },
    { value: 906, text: '906 - Lomé, Togo - Embaixada do Brasil' },
    { value: 470, text: '470 - Londres, Inglaterra - Consulado-Geral do Brasil e Embaixada' },
    { value: 293, text: '293 - Los Angeles, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 20, text: '020 - Luanda, Angola - Embaixada do Brasil' },
    { value: 986, text: '986 - LusaKa, Zâmbia - Embaixada do Brasil' },
    { value: 281, text: '281 - Madri, Espanha - Consulado Geral do Brasil e Embaixada' },
    { value: 406, text: '406 - Malabo, Guiné-Equatorial - Embaixada do Brasil' },
    { value: 640, text: '640 - Manágua, Nicarágua - Embaixada do Brasil' },
    { value: 310, text: '310 - Manila, Filipinas - Embaixada do Brasil' },
    { value: 620, text: '620 - Maputo, Moçambique - Embaixada do Brasil' },
    { value: 675, text: '675 - Mascate, Omã - Embaixada do Brasil' },
    { value: 54, text: '054 - Mendoza, Argentina - Consulado-Geral do Brasil' },
    { value: 294, text: '294 - Miami, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 510, text: '510 - Milão, Itália - Consulado-Geral do Brasil' },
    { value: 95, text: '095 - Minsk, Belarus - Embaixada do Brasil' },
    { value: 575, text: '575 - Monróvia, Libéria - Embaixada do Brasil' },
    { value: 952, text: '952 - Montevidéu, Uruguai - Consulado-Geral e Embaixada' },
    { value: 140, text: '140 - Montreal, Canadá - Consulado-Geral do Brasil' },
    { value: 820, text: '820 - Moscou, Rússia - Embaixada do Brasil' },
    { value: 451, text: '451 - Mumbai, Índia - Consulado-Geral do Brasil' },
    { value: 12, text: '012 - Munique, Alemanha - Consulado-Geral do Brasil' },
    { value: 540, text: '540 - Nagoia, Japão - Consulado-Geral do Brasil' },
    { value: 770, text: '770 - Nairóbi, Quênia - Embaixada do Brasil' },
    { value: 80, text: '080 - Nassau, Bahamas - Embaixada do Brasil' },
    { value: 157, text: '157 - Nicósia, Chipre - Embaixada do Brasil' },
    { value: 450, text: '450 - Nova Delhi, Índia - Embaixada do Brasil' },
    { value: 295, text: '295 - Nova York, Estados Unidos da América - Consulado-Geral' },
    { value: 605, text: '605 - Nouakchott, Mauritânia - Embaixada do Brasil' },
    { value: 660, text: '660 - Oslo, Noruega - Embaixada do Brasil' },
    { value: 141, text: '141 - Ottawa, Canadá - Embaixada do Brasil' },
    { value: 680, text: '680 - Cidade do Panamá, Panamá - Embaixada do Brasil' },
    { value: 870, text: '870 - Paramaribo, Suriname - Embaixada do Brasil' },
    { value: 330, text: '330 - Paris, França - Consulado-Geral e Embaixada' },
    { value: 51, text: '051 - Paso de Los Libres, Argentina - Consulado do Brasil' },
    { value: 704, text: '704 - Pedro Juan Caballero, Paraguai - Consulado do Brasil' },
    { value: 160, text: '160 - Pequim, China - Embaixada do Brasil' },
    { value: 751, text: '751 - Porto, Portugal - Consulado-Geral do Brasil' },
    { value: 410, text: '410 - Porto Príncipe, Haiti - Embaixada do Brasil' },
    { value: 910, text: '910 - Port-of-Spain, Trinidad e Tobago - Embaixada do Brasil' },
    { value: 800, text: '800 - Praga, República Tcheca - Embaixada do Brasil' },
    { value: 130, text: '130 - Praia, Cabo Verde - Embaixada do Brasil' },
    { value: 2, text: '002 - Pretória, África do Sul - Embaixada do Brasil' },
    { value: 973, text: '973 - Puerto Ayacucho, Venezuela - Vice-Consulado do Brasil' },
    { value: 52, text: '052 - Puerto Iguazu, Argentina - Consulado do Brasil' },
    { value: 116, text: '116 - Puerto Quijarro, Bolívia - Consulado do Brasil' },
    { value: 195, text: '195 - Pyongyang, Coréia do Norte - Embaixada do Brasil' },
    { value: 270, text: '270 - Quito, Equador - Embaixada do Brasil' },
    { value: 600, text: '600 - Rabat, Marrocos - Embaixada do Brasil' },
    { value: 30, text: '030 - Riade, Arábia Saudita - Embaixada do Brasil' },
    { value: 953, text: '953 - Rio Branco, Uruguai - Vice-Consulado do Brasil' },
    { value: 954, text: '954 - Rivera, Uruguai - Consulado-Geral do Brasil' },
    { value: 511, text: '511 - Roma, Itália - Consulado-Geral e Embaixada' },
    { value: 237, text: '237 - Roseau, Dominica - Embaixada do Brasil' },
    { value: 421, text: '421 - Roterdã, Holanda - Consulado-Geral do Brasil' },
    { value: 355, text: "355 - Saint George's, Granada - Embaixada do Brasil" },
    { value: 391, text: "391 - Saint Georges de L'Oyapock, Guiana Francesa - Consulado-Geral do Brasil" },
    { value: 25, text: "025 - Saint John's, Antígua e Barbuda - Embaixada do Brasil" },
    { value: 705, text: '705 - Saltos do Guaíra, Paraguai - Consulado do Brasil' },
    { value: 115, text: '115 - Santa Cruz de La Sierra, Bolívia - Consulado-Geral do Brasil' },
    { value: 972, text: '972 - Santa Elena do Uairén, Venezuela - Vice-Consulado do Brasil' },
    { value: 150, text: '150 - Santiago, Chile - Consulado-Geral do Brasil e Embaixada' },
    { value: 780, text: '780 - São Domingos, República Dominicana - Embaixada do Brasil' },
    { value: 296, text: '296 - São Francisco, Estados Unidos da América - Consulado-Geral do Brasil' },
    { value: 210, text: '210 - São José, Costa Rica - Embaixada do Brasil' },
    { value: 250, text: '250 - São Salvador, El Salvador - Embaixada do Brasil' },
    { value: 825, text: '825 - São Tomé, São Tomé e Principe - Embaixada do Brasil' },
    { value: 125, text: '125 - Sarajevo, Bósnia e Herzegovina - Embaixada do Brasil' },
    { value: 190, text: '190 - Seul, Coréia do Sul - Embaixada do Brasil' },
    { value: 120, text: '120 - Sófia, Bulgária - Embaixada do Brasil' },
    { value: 61, text: '061 - Sydney, Austrália - Consulado-Geral do Brasil' },
    { value: 326, text: '326 - Taipé, Taiwan (Formosa) - Escritório Comercial' },
    { value: 785, text: '785 - Talin, Estônia - Embaixada do Brasil' },
    { value: 788, text: '788 - Tbilisi, Geórgia - Embaixada do Brasil' },
    { value: 480, text: '480 - Teerã, Irã - Embaixada do Brasil' },
    { value: 430, text: '430 - Tegucigalpa, Honduras - Embaixada do Brasil' },
    { value: 500, text: '500 - Tel Aviv, Israel - Embaixada do Brasil' },
    { value: 7, text: '007 - Tirana, Albânia - Embaixada do Brasil' },
    { value: 541, text: '541 - Tóquio, Japão - Consulado-Geral do Brasil e Embaixada' },
    { value: 142, text: '142 - Toronto, Canadá - Consulado-Geral do Brasil' },
    { value: 580, text: '580 - Trípoli, Líbia - Embaixada do Brasil' },
    { value: 920, text: '920 - Túnis, Tunísia - Embaixada do Brasil' },
    { value: 127, text: '127 - Uagadugu, Burkina Faso - Embaixada do Brasil' },
    { value: 139, text: '139 - Vancouver, Canadá - Consulado-Geral do Brasil' },
    { value: 740, text: '740 - Varsóvia, Polônia - Embaixada do Brasil' },
    { value: 70, text: '070 - Viena, Áustria - Embaixada do Brasil' },
    { value: 297, text: '297 - Washington D.C., Estados Unidos da América - Consulado-Geral do Brasil e Embaixada' },
    { value: 670, text: '670 - Wellington, Nova Zelândia - Embaixada do Brasil' },
    { value: 630, text: '630 - Windhoek, Namíbia - Embaixada do Brasil' },
    { value: 161, text: '161 - Xangai, China - Consulado-Geral do Brasil' },
    { value: 608, text: '608 - Yangon, Mianmar - Embaixada do Brasil' },
    { value: 216, text: '216 - Zagreb, Croácia - Embaixada do Brasil' },
    { value: 861, text: '861 - Zurique, Suíça - Consulado-Geral do Brasil' }
  ],

  controlecaixa_codigo_imovel: [
    { value: 1, text: '1 - Exploração individual (Imóvel próprio)' },
    { value: 2, text: '2 - Condomínio' },
    { value: 3, text: '3 - Imóvel arrendado' },
    { value: 4, text: '4 - Parceria' },
    { value: 5, text: '5 - Comodato' },
    { value: 6, text: '6 - Outros' }
  ],

  controlecaixa_codigo_conta: [
    { value: 0, text: '000 - Em espécie' },
    { value: 999, text: '999 - Numerário em trânsito' }
  ],

  controlecaixa_tipo_documento: [
    { value: 1, text: '1 - Nota Fiscal' },
    { value: 2, text: '2 - Fatura' },
    { value: 3, text: '3 - Recibo' },
    { value: 4, text: '4 - Contrato' },
    { value: 5, text: '5 - Folha de Pagamento' },
    { value: 6, text: '6 - Outros' }
  ],

  controlecaixa_tipo_lancamento: [
    { value: 1, text: '1 - Receita da Atividade Rural' },
    { value: 2, text: '2 - Despesas de custeio e investimentos' },
    { value: 3, text: '3 - Receita de produtos entregues no ano referente a adiantamento de recursos financeiros' }
  ]

}



// WEBPACK FOOTER //
// ./src/translate/pt_br/value.js